import { Component } from '@angular/core';
import { SkeletonBlock } from '../../../../shared/components/skeleton/skeleton-block';

/** Desktop summary cards per row (two rows). */
const REVIEW_DESKTOP_CARD_COUNT = 3;
/** Tablet/desktop total summary cards in one 3-col grid. */
const REVIEW_TABLET_CARD_COUNT = 6;
/** Mobile stacked summary cards (390pt prototype). */
const REVIEW_MOBILE_CARD_COUNT = 4;
/** Cost line placeholders in the estimate column. */
const REVIEW_ESTIMATE_LINE_COUNT = 8;
/** Desktop card body line widths (`skelReview`). */
const REVIEW_DESKTOP_CARD_LINE_WIDTHS = ['82%', '64%', '90%', '72%'] as const;
/** Tablet card body line widths (768pt prototype). */
const REVIEW_TABLET_CARD_LINE_WIDTHS = ['84%', '66%', '92%', '74%', '58%'] as const;
/** Mobile card body line widths (390pt prototype). */
const REVIEW_MOBILE_CARD_LINE_WIDTHS = ['54%', '70%', '88%', '76%', '64%'] as const;
/** Mobile notice copy line widths. */
const REVIEW_MOBILE_NOTICE_LINE_WIDTHS = ['100%', '94%', '62%'] as const;

/**
 * Review & Pay content skeleton (OM-715).
 * Desktop mirrors `skelReview`; tablet matches 768pt estimate (coupon top-right); mobile 390pt.
 */
@Component({
  selector: 'app-review-and-pay-skeleton',
  imports: [SkeletonBlock],
  templateUrl: './review-and-pay-skeleton.html',
  styleUrl: './review-and-pay-skeleton.scss',
})
export class ReviewAndPaySkeleton {
  protected readonly desktopCardPlaceholders = Array.from(
    { length: REVIEW_DESKTOP_CARD_COUNT },
    (_, index) => index,
  );

  protected readonly tabletCardPlaceholders = Array.from(
    { length: REVIEW_TABLET_CARD_COUNT },
    (_, index) => index,
  );

  protected readonly mobileCardPlaceholders = Array.from(
    { length: REVIEW_MOBILE_CARD_COUNT },
    (_, index) => index,
  );

  protected readonly estimateLinePlaceholders = Array.from(
    { length: REVIEW_ESTIMATE_LINE_COUNT },
    (_, index) => index,
  );

  protected readonly desktopCardLineWidths = REVIEW_DESKTOP_CARD_LINE_WIDTHS;
  protected readonly tabletCardLineWidths = REVIEW_TABLET_CARD_LINE_WIDTHS;
  protected readonly mobileCardLineWidths = REVIEW_MOBILE_CARD_LINE_WIDTHS;
  protected readonly mobileNoticeLineWidths = REVIEW_MOBILE_NOTICE_LINE_WIDTHS;
}
